var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersons({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M22.9168 21.875V19.7917C22.9168 17.8502 21.5889 16.2188 19.7918 15.7563M16.146 3.42787C17.673 4.04599 18.7502 5.54303 18.7502 7.29167C18.7502 9.0403 17.673 10.5373 16.146 11.1555M17.7085 21.875C17.7085 19.9336 17.7085 18.9629 17.3913 18.1972C16.9684 17.1762 16.1573 16.3651 15.1363 15.9422C14.3706 15.625 13.3999 15.625 11.4585 15.625H8.3335C6.39207 15.625 5.42136 15.625 4.65565 15.9422C3.6347 16.3651 2.82356 17.1762 2.40066 18.1972C2.0835 18.9629 2.0835 19.9336 2.0835 21.875M14.0627 7.29167C14.0627 9.59285 12.1972 11.4583 9.896 11.4583C7.59481 11.4583 5.72933 9.59285 5.72933 7.29167C5.72933 4.99048 7.59481 3.125 9.896 3.125C12.1972 3.125 14.0627 4.99048 14.0627 7.29167Z",
    stroke: "#956446",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersons);
export default __webpack_public_path__ + "static/media/persons.cde3873e664219e249799d0b40e942b3.svg";
export { ForwardRef as ReactComponent };